import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, SrOnly, Tooltip, Text } from 'pcln-design-system'

const StyledButtonOption = styled(Button)`
  margin: 0;
  outline-offset: -1px;
  box-shadow: none;
  border-radius: 0;
  padding-right: 0;
  padding-left: 0;
  white-space: nowrap;

  &:hover {
    box-shadow: none;
  }
`

class SegmentedControl extends React.Component {
  constructor() {
    super()

    this.state = {
      showTooltip: false,
    }

    this.openTooltip = this.openTooltip.bind(this)
    this.closeTooltip = this.closeTooltip.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  openTooltip() {
    this.setState({
      showTooltip: true,
    })
  }

  closeTooltip() {
    this.setState({
      showTooltip: false,
    })
  }

  handleClick() {
    this.props.handleClick({
      value: this.props.value,
      highlighted: this.props.highlighted,
      selected: this.props.selected,
    })
  }

  render() {
    const { value, highlighted, disabled, tooltipText, tooltipPosition, hidePlus } = this.props
    const tooltipPositionFinal = {
      bottom: !tooltipPosition.top,
      center: !tooltipPosition.left && !tooltipPosition.right,
      ...tooltipPosition,
    }

    return (
      <StyledButtonOption
        width={1}
        size='medium'
        highlighted={highlighted}
        onMouseEnter={this.openTooltip}
        onFocus={this.openTooltip}
        onBlur={this.closeTooltip}
        onMouseLeave={this.closeTooltip}
        onClick={this.handleClick}
        variation={highlighted ? 'fill' : 'outline'}
        color='primary'
        disabled={disabled}
      >
        <Text bold fontWeight='bold' fontSize={1}>
          {`${value}${hidePlus ? '' : ' +'}`}
        </Text>
        {this.state.showTooltip && tooltipText && (
          <Tooltip bg='background.lightest' color='text' {...tooltipPositionFinal}>
            {tooltipText}
          </Tooltip>
        )}
        <SrOnly>({highlighted ? '' : 'un'}selected)</SrOnly>
      </StyledButtonOption>
    )
  }
}

SegmentedControl.propTypes = {
  disabled: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  highlighted: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  tooltipPosition: PropTypes.shape({
    bottom: PropTypes.bool,
    center: PropTypes.bool,
    left: PropTypes.bool,
    right: PropTypes.bool,
    top: PropTypes.bool,
  }),
  tooltipText: PropTypes.string,
  value: PropTypes.number.isRequired,
  hidePlus: PropTypes.bool,
}

SegmentedControl.defaultProps = {
  disabled: false,
  hidePlus: false,
  tooltipPosition: {},
}

export default SegmentedControl
